// Parses a route param string to a positive-or-any number, returning undefined
// for missing or non-numeric values (e.g. optional `:id?` routes).
export const parseNumericParam = (id?: string): number | undefined =>
  id !== undefined && !isNaN(+id) ? +id : undefined;
